
// Import module styles.
import "./selectExercise.view.less";

// Import application modules.
import searchHelper from "/main/js/utils/searchHelper";

// ----------------------------------------------------------------------------------- //
// ----------------------------------------------------------------------------------- //

// Define controllers.
window.mcpkrx = {
	FormController
};

// Todo: this isn't how Alpine.js components work, I'm just trying to get rid of inline
// script tags. Will need to refactor this later.
function FormController() {

	var searchInput = document.querySelector( ".search-bar__input" );
	var searchClear = document.querySelector( ".search-bar__button" );

	var searchTargets = Array
		.from( document.querySelectorAll( ".search-target" ) )
		.map(
			( node ) => {

				return({
					node: node,
					keywords: searchHelper.normalizePipeText( node.dataset.keywords )
				});

			}
		)
	;

	searchInput.addEventListener( "input", handleSearchInput );
	searchClear.addEventListener( "click", handleSearchClear );

	function handleSearchInput() {

		var keywords = searchHelper.normalizeText( searchInput.value );

		for ( var target of searchTargets ) {

			target.node.hidden = ! searchHelper.isFuzzyMatchMulti( target.keywords, keywords );

		}

	}

	function handleSearchClear() {

		searchInput.value = "";
		handleSearchInput();

	}

}
